//@ts-check
var omit = function omit(obj, paths) {
  var rest = {};
  Object.keys(obj).forEach(function (key) {
    if (paths.indexOf(key) === -1) rest[key] = obj[key];
  });
  return rest;
};

export default omit;